import * as z from "zod";

export const TRACKING_SAMPLES_PER_CARRIER = 3;
export const TRACKING_MAX_CARRIERS = 20;

const TrackingSampleResultSchema_ = z.object({
  trackingCode: z.string(),
  success: z.boolean(),
  /** Raw carrier from Shopify fulfillment */
  rawCarrier: z.string().nullish(),
  /** Carrier after applying merchant mappings */
  resolvedCarrier: z.string().nullish(),
  status: z.string().nullish(),
  provider: z.string().nullish(),
  error: z.string().nullish(),
  /** True if primary provider failed and fallback was used */
  usedFallback: z.boolean().nullish(),
  /** Error message from the primary provider if fallback was used */
  primaryError: z.string().nullish(),
});

export const TrackingSampleResultSchema: z.ZodType<TrackingSampleResult> =
  TrackingSampleResultSchema_;

export interface TrackingSampleResult
  extends z.infer<typeof TrackingSampleResultSchema_> {}

const CarrierSamplesResultSchema_ = z.object({
  carrier: z.string(),
  samples: z.array(TrackingSampleResultSchema),
});

export const CarrierSamplesResultSchema: z.ZodType<CarrierSamplesResult> =
  CarrierSamplesResultSchema_;

export interface CarrierSamplesResult
  extends z.infer<typeof CarrierSamplesResultSchema_> {}

export const TestTrackingSamplesInputSchema = z.object({
  teamId: z.string(),
  carriers: z.array(z.string()),
  samplesPerCarrier: z.number().default(TRACKING_SAMPLES_PER_CARRIER),
});

export const TestTrackingSamplesOutputSchema = z.object({
  results: z.array(CarrierSamplesResultSchema),
});

export type TestTrackingSamplesInput = z.infer<
  typeof TestTrackingSamplesInputSchema
>;
export type TestTrackingSamplesOutput = z.infer<
  typeof TestTrackingSamplesOutputSchema
>;

export const testTrackingSamples = {
  name: "testTrackingSamples" as const,
  input: TestTrackingSamplesInputSchema,
  output: TestTrackingSamplesOutputSchema,
};
